import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditBrandingPayload } from '@app-store/slices/onbordingOrganizer/editBranding'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IEditBrandingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.onbordingOrganizer.editBranding

function* editBrandingSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.patch(`/event/branding/${payload.brandingId}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
            notification.success({
                message: 'Branding updated successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editBrandingSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editBrandingSagaTask)
}

export default editBrandingSaga
